import { createApp } from 'vue';
import VueOnsen from 'vue-onsenui';
import * as components from 'vue-onsenui/esm/components';
import axios from 'axios';

import store from '@/store/indexStore';
import '@/assets/styles/common.css';
import panZoom from 'vue-panzoom';
import i18n from './i18n'; // i18nのインポート
import App from './App.vue';
import router from './router';

// Onsen UI Styling and Icons
import 'onsenui/css/css-components-src/onsen-css-components.css';
import 'onsenui/css/onsenui.css';

// Vue3でのアプリケーション初期化
const app = createApp(App);

// プラグインの登録
app.use(VueOnsen);
app.use(panZoom);

// Vue Router, Vuex Store, i18nの登録
app.use(router);
app.use(store);
app.use(i18n);

// ダブルタップ抑止のグローバル設定
document.addEventListener(
  'dblclick',
  (event) => {
    event.preventDefault();
  },
  false
);

// グローバルプロパティの設定
app.config.globalProperties.$axios = { ...axios };

// Android端末でiOS用の画面を表示するため、Auto Stylingを無効化
app.config.globalProperties.$ons = VueOnsen;
app.config.globalProperties.$ons.disableAutoStyling();

// VueOnsenのコンポーネントを登録
Object.values(components).forEach((component) => {
  app.component(component.name, component);
});

// アプリケーションのマウント
app.mount('#app');
